export const steps = (state = [], action) => { 
    switch (action.type) {
        case 'INIT_STEPS':
            return 0;
        case 'STEPS_CHANGE':
            return action.value;      
        default:
            return state
    }
}